import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {DiscordContentFrameController} from './content_frame/DiscordContentFrameController'

export class DiscordInstance {
    static _discordInstance: DiscordContentFrameController

    static getDiscordInstance(): DiscordContentFrameController {
        if(!UIUtilsEjsVariables.isUserOnDiscord) throw new Error('Not on Discord Activity')
        if(this._discordInstance == undefined) this._discordInstance = new DiscordContentFrameController()
        return this._discordInstance
    }
}
